const copyObject = (originalObject) => {
  const copyArray = (objectValue) => objectValue.map((valueInArray) => {
    if (typeof valueInArray === 'object') {
      return copyObject(valueInArray)
    }
    return valueInArray
  })
  const copyDeep = () => {
    const objectKeys = Object.keys(originalObject)

    return objectKeys.reduce((newObject, queryKey) => {
      const value = originalObject[queryKey]
      const extractObject = (objectValue) => (Array.isArray(objectValue) ? copyArray(objectValue) : copyObject(objectValue))
      newObject[queryKey] = value && typeof value === 'object' ? extractObject(value) : value
      return newObject
    }, {})
  }

  return originalObject && copyDeep()
}

const createObject = (originalObject, overwrites) => {
  const newObject = copyObject(originalObject)

  if (typeof overwrites === 'object' && overwrites) {
    Object.keys(overwrites).forEach((overwriteKey) => {
      newObject[overwriteKey] = overwrites[overwriteKey]
    })
  }

  return newObject
}

export { copyObject, createObject }
